declare const jhsapp: any;

/**
 * 获取用户token
 * @returns {Promise<string | null>} 返回token字符串，如果没有token则返回null
 */
export const getToken = async (): Promise<string | null> => {
  try {
    const token = jhsapp.getToken();
    // const token = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJlbnYiOiJ0ZXN0aW5nIiwic3ViIjo5Nzg4OTQsImlzcyI6Imh0dHBzOi8vYXBpLXRlc3RpbmcuamlodWFuc2hlLmNvbS9hcGkvbWFya2V0L2F1dGgvbG9naW4iLCJpYXQiOjE3NDcwNTM3NzEsImV4cCI6MTc1MjIzNzc3MSwibmJmIjoxNzQ3MDUzNzcxLCJqdGkiOiJVUlV6Mk9Ldmk5aHIwcGlrIn0.YQz9xYtGkFiX5BSS32FM2-mvHNCoF6MUtHcsUt-ZrXE';
    return token;
  } catch (error) {
    // console.error('获取token失败:', error);
    return null;
  }
};

/**
 * 检查用户是否为游客
 * @returns {Promise<boolean>} 返回是否为游客
 */
export const isGuest = async (): Promise<boolean> => {
  try {
    const token = await getToken();
    return !token;
    // 调试时设为false
    // return false;
  } catch (error) {
    console.log('isGuest');
    // console.error('检查用户是否为游客失败:', error);
    return true;
  }
};

/**
 * 检查用户是否为游客，并跳转登录页面
 * @param next 跳转的回调函数
 * @returns {Promise<boolean>} 返回是否为游客
 */
export const checkLoginAndGo = async (next: () => void): Promise<boolean> => {
    const guest = await isGuest();
    // console.log(guest, 'guest');
    if (guest) {
        jhsapp.router('https://www.jihuanshe.com/app/login');
        return false;
    }
    next();
    return true;
}